import { paletteBase } from '@abg/kit-base';
import type { AbgSxProps } from '@abg/typings';

import { LocationIconModeType } from './location-icon.types';

export const iconStyle: AbgSxProps = (theme) => ({
  fontSize: '16px',
  color: theme.palette.text.secondary,
});

const listItemIconStyle: AbgSxProps = {
  fontSize: '16px',
  color: paletteBase.black,
};

const inputIconStyle: AbgSxProps = (theme) => ({
  fontSize: '16px',
  color: theme.palette.text.secondary,
  [theme.breakpoints.down('md')]: {
    marginRight: '8px',
  },
});

const detailIconStyle: AbgSxProps = (theme) => ({
  fontSize: '24px',
  color: theme.palette.text.primary,
});

export const getIconStyle = (
  mode: LocationIconModeType | undefined,
): AbgSxProps => {
  switch (mode) {
    case 'list-option': {
      return listItemIconStyle;
    }

    case 'input': {
      return inputIconStyle;
    }

    case 'detail': {
      return detailIconStyle;
    }

    default: {
      return {};
    }
  }
};
